import type { PollResultsState } from './types'

interface StateWithPollResults {
  communicationBoardPollResults: PollResultsState
}

export const selectPollResultsState = (state: StateWithPollResults) => state.communicationBoardPollResults
